import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import Immigration from "../assets/images/public-pages/Immigration-about.png";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ClassImg from "../assets/images/public-pages/class-second.png";
import Tick from "../assets/images/public-pages/about-tick.svg"
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import AIPowered from "../assets/images/public-pages/AI-Powered.svg";
import Training from "../assets/images/public-pages/Training-Support.svg";
import CoursePlans from "../assets/images/public-pages/CoursePlans.svg"
import Feedback from "../assets/images/public-pages/Feedback.svg"
import OurSuccessBg from "../assets/images/public-pages/oursuccessbackground.png";
import Smalltick from "../assets/images/public-pages/tick-circle-green.svg";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import HeroSectionUpdatedSecond from "components/PublicPagesReusable/HeroSectionUpdatedSecond";
import NocBanner from "components/PublicPagesReusable/NocBanner";

const About = () => {
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
  };

    const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text text-center"> 
          Helping 50,000+ Students' <br /> 
          <span className="text-success">Achieve Their Dreams</span> 
      </h1>
    );
  };

    const heroData = {
    badge: "Australia’s Leading English Proficiency Centre",
    title: heroWorkTitle,
    subtitle: "Founded by a 14-time perfect PTE scorer, Language Academy is Australia's most trusted English proficiency and immigration test preparation network — built to help you master the system, not just the language.",
    
    users: [
      
    ],
    trustText: "",
    
    bottomStatsText: [
      { value: "8",highlight:'+', label: "Years of NAATI Expertise" },
      { value: "50k", highlight:'+', label: "Students' Helped" },
      { value: "10", highlight:'+', label: "Global Locations" },
      { value: "95", highlight:'%', label: "Success Rate" }
    ]
  };
  
   const contentSection = () => {
    return (
      <p className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">Our Story:  </span> Transforming<br />
         Lives Through Language Mastery
      </p>
    )
  }

   const skillAreaTitle2 = () => {
    return (
      <h2 className="top-section-text FS40FW600 mb-0">
        Our Approach:<br />
        <span className="green-text"><em>Science Meets Success</em></span>
      </h2>
    );
  };

  const institutionCardData = [
    { 
      smallHeading : "Universities",
      title : "Academic Partners",
      list : ["University of Sydney","University of Melbourne",
        "RMIT University","University of Queensland"
      ]
    },
     { 
      smallHeading : "MEDIA",
      title : "Featured In",
      list : ["ABC Australia","Radio Haanji",
        "Fiji Times"
      ]
    },
     { 
      smallHeading : "INDUSTRY",
      title : "Recognition",
      list : ["562K+ YouTube subscribers","Algorithm-based test prep pioneers",
        "Featured across Australian media","NAATI-accredited trainers"
      ]
    }
  ]

  const styleCards = [
      {
        title: "AI-Powered Precision",
        text: "Our proprietary practice platform mirrors actual exam algorithms, providing the most accurate scoring system in the industry. Updated weekly to reflect the latest test changes.",
        color: "#fff",
        img: AIPowered,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Algorithm Mastery",
        text: 'While others focus on "better English," we target the exact mechanics behind how these exams score responses. Understanding the system is the key to consistently high scores.',
        color: "#fff",
        img: Training,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Real-Time Adaption",
        text: "We're the first in the industry to respond to test updates, ensuring our strategies, materials, and mobile app are always in sync with current exam standards.",
        color: "#fff",
        img: CoursePlans,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Personalized Guidance",
        text: "Expert trainers provide 1-on-1 feedback tailored to your specific challenges. You're never just another number, you're a future success story.",
        color: "#fff",
        img: Feedback,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
    ];

  return (
    <React.Fragment>
      <Helmet>
        <title>About LA Language Academy | Expert PTE & NAATI Preparation</title>
        <meta name="description" content="Learn about LA Language Academy, your trusted partner for PTE and NAATI exam preparation. Discover our mission, values & expert team dedicated to your success." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/about`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="About LA Language Academy | Expert PTE & NAATI Preparation" />
        <meta name="twitter:description" content="Learn about LA Language Academy, your trusted partner for PTE and NAATI exam preparation. Discover our mission, values & expert team dedicated to your success." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/about`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="About LA Language Academy | Expert PTE & NAATI Preparation" />
        <meta property="og:description" content="Learn about LA Language Academy, your trusted partner for PTE and NAATI exam preparation. Discover our mission, values & expert team dedicated to your success." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
     <div className="new-design">
            <Header />
               {/* <HeroSectionUpdatedSecond data={heroData} /> */}
               <NocBanner
          data={heroData}
          extraClass={"contact-hero-section pte-scoring"}
          extraClass2={"align-items-start"}
        />
          <div className="custom-container py-5 mt-5">
            <div className="py-5">
              <ContentImageSection
              contentSection={contentSection}
              quoteText="Founded with a simple yet powerful vision: to help students' master the systems behind English proficiency tests, not just the language itself."
              btnLink="/auth/register"
              paragraphs={["What started as a single classroom has grown into Australia's most trusted test preparation network, with 10 branches across Australia, India, and Nepal."," Over the past 8+ years, we've helped more than 50,000 students' achieve their immigration, education, and career goals."," We're not just another language school. We're the bridge between your current abilities and your future success."]}
              btnText="Discover Our Proven Approach"
              btnClassName="mt-4"
              image={Immigration}
              imageClassName="immigration-test-img"
              btnImg="/images/web-new-images/new-dark-arrow.svg"
            />
          </div> 
        </div>
          <section className="about-section py-5 text-white">
                    <div className="custom-container">
                      <div className="row g-4 align-items-start">
                        {/* LEFT PROFILE */}
                        <div className="col-lg-4">
                          <div className="profile-card">
                            <img
                              src="/images/web-new-images/HomePageImage/Founder.png"
                              alt="founder"
                              className="img-fluid rounded-4 mb-3"
                            />
                            <div className="founder-quote pt-2">
                              <i>
                              After scoring perfect 90s in the PTE exam 14 times, I realized there was a fundamental misunderstanding about how these tests work. Language Academy was built to bridge this gap, helping students' master the system, not just the language.
                              </i>
                            </div>
                          </div>
                        </div>
          
                        {/* RIGHT CONTENT */}
                        <div className="col-lg-8">
                          {/* Top Heading */}
                          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4-5">
                            <div>
                              <span className="m-0 main-title FS40FW600">Meet The Founder </span>
                              <h2 className="text-success FS40FW600 m-0">
                                Varun Dhawan
                              </h2>
                            </div>
          
                            {/* <button className="primary-btn mt-3 mt-lg-0" onClick={() => navigate("/auth/register")}>
                              Become A Member{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="Register Now"
                              />
                            </button> */}
                              <ButtonComp link={"/auth/register"} btnText={"Learn From The Expert"} img="/images/web-new-images/new-dark-arrow.svg"/>
                          </div>
          
                          {/* Authority Card */}
                          <div className="info-card  mb-4 border-0">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <div className="row">
                                  <div className="col-6">
                                    <div className="icon-box mb-2 d-flex">
                                      <img
                                        src="/images/web-new-images/HomePageImage/authority.svg"
                                        alt="icon"
                                      />
                                    </div>
                                    <span className="FS24FW500 fw-600 plus-sans">The Expert Who Cracked the Code
                                    </span>
                                  </div>
                                  <div className="col-6 text-end">
                                    <img
                                      src="/images/web-new-images/HomePageImage/youtube-subscriptions.svg"
                                      alt="yt"
                                    />{" "}
                                    <br />
                                  </div>
                                </div>
                                <p className="plus-sans FS16FW500 fw-400">
                                 Varun Dhawan didn't just master the PTE exam, he achieved a perfect 90 score 14 times. But his real breakthrough came when he realized that most students' were solving the wrong problem.
                                </p>
                              </div>
                            </div>
                          </div>
          
                          {/* Bottom Cards */}
                          <div className="row g-4">
                            <div className="col-md-8">
                              <div className="info-card p-4 h-100 border-0">
                                <div className="mb-2 d-flex justify-content-start align-items-center gap-3">
                                  <img
                                    src="/images/web-new-images/HomePageImage/briefcase.svg"
                                    alt="icon"
                                  />
                                  <span className="FS24FW500 fw-600">Our Founder's Credentials</span>
                                </div>
                                 <div className="cis-list-columns quote-list">
                                              
                                                 <ul className="feature-list text-white m-0">
                                                  
                                                     <li  className="FS15FW500 fw-normal" >Perfect PTE scorer <span className="fw-bold">(90/90) achieved 14 times</span></li>

                                                     <li  className="FS15FW500 fw-normal" > <span className="fw-bold"> 8+ years </span> specializing in English test preparation </li>

                                                     <li  className="FS15FW500 fw-normal" ><span className="fw-bold">562K+</span> YouTube subscribers trust his expertise</li>

                                                     <li  className="FS15FW500 fw-normal" >Recognized authority in algorithm-based test preparation</li>

                                                 </ul>
                                              
                                             </div>
                              </div>
                            </div>
          
                            <div className="col-md-4">
                              <div className="info-card p-4 h-100 border-0">
                                
                                <p style={{ lineHeight:"2" }} className="plus-sans FS15FW400 fw-400 ">
                                  Today, Varun's methodology has become the gold standard for test preparation, helping thousands of students' achieve scores they once thought were impossible.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="custom-container py-5">
                               {/* Top: Title */}
                               <div className="text-center mb-5">
                                 <h2 className="top-section-text FS40FW600 mb-0">
                                    <span className="green-text"><em>What We Do</em></span><br />
                                   <span className="text-dark">Four Pathways To Success</span>
                                 </h2>
                                 <p className="mt-3 plus-sans FS18FW400" style={{ color: '#383838' }}>We specialize in the tests that matter most for your future:</p>
                               </div>
                   
                               {/* Bottom: Left list + Center image + Right list */}
                               <div className="row g-4 align-items-center">
                                 {/* Left column - 2 items */}
                                 <div className="col-lg-4">
                                   <div className="d-flex flex-column gap-4">
                                     {[
                                       { title: "PTE Academic", desc: "The globally recognized standard for university admissions and visa applications. Our AI-powered approach ensures you understand the 22 question types and integrated scoring system." },
                                       { title: "IELTS", desc: "The traditional English proficiency test, perfected through our systematic approach to band score improvement and examiner expectations." },
                                     ].map((item, i) => (
                                       <div key={i} className="bg-white p-4 rounded-4 border shadow-sm h-100" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
                                         <img src={Tick} alt="tick" className="mb-3" style={{ width: '52px', height: '52px' }} />
                                         <h4 className="plus-sans fw-700 mb-2" style={{ fontSize: '22px', color: '#141414' }}>{item.title}</h4>
                                         <p className="plus-sans fw-400 mb-0" style={{ fontSize: '15px', lineHeight: '160%', color: '#383838' }}>{item.desc}</p>
                                       </div>
                                     ))}
                                   </div>
                                 </div>
                   
                                 {/* Center - Image */}
                                 <div className="col-lg-4">
                                   <img
                                     src={ClassImg}
                                     alt="Success Pathways"
                                     className="w-100 rounded-5"
                                     style={{ height: '560px', objectFit: 'cover', border: '1px solid rgba(0,0,0,0.05)' }}
                                   />
                                 </div>
                   
                                 {/* Right column - 2 items */}
                                 <div className="col-lg-4">
                                   <div className="d-flex flex-column gap-4">
                                     {[
                                       { title: "PTE Core", desc: "Specifically designed for Canadian immigration. Get results in 48 hours vs. 13+ days for IELTS, with our specialized Canadian pathway preparation." },
                                       { title: "NAATI CCL", desc: "Secure 5 bonus points for Australian permanent residency through our expert translation and interpretation training in 12 languages." },
                                     ].map((item, i) => (
                                       <div key={i} className="bg-white p-4 rounded-4 border shadow-sm h-100" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
                                         <img src={Tick} alt="tick" className="mb-3" style={{ width: '52px', height: '52px' }} />
                                         <h4 className="plus-sans fw-700 mb-2" style={{ fontSize: '22px', color: '#141414' }}>{item.title}</h4>
                                         <p className="plus-sans fw-400 mb-0" style={{ fontSize: '15px', lineHeight: '160%', color: '#383838' }}>{item.desc}</p>
                                       </div>
                                     ))}
                                   </div>
                                 </div>
                               </div>

                               <div className="text-center mt-5">
                                 <p className="plus-sans fw-600 mb-4" style={{ fontStyle: 'italic', fontSize: '18px', color: '#141414' }}>
                                   Each program is built around the unique algorithm patterns that<br/> determine success in that particular test.
                                 </p>
                               <div className="d-flex justify-content-center">
                                   <ButtonComp link="/auth/register" btnText="Explore Our Programs" img="/images/web-new-images/new-dark-arrow.svg" />
                                 </div>
                               </div>
                             </div>

                             <SkillAreas
                               background="white"
                               color="#141414"
                               leftSection={false}
                               center="text-center d-flex justify-content-center"
                               skillAreaTitle={skillAreaTitle2}
                               lifestyleCards={styleCards}
                               noTilt={true}
                               btnText2="Book a Free Trial Class"
                               btnLink2={() => {
                               const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
                               modal.show();
                               }}
                               img="/images/web-new-images/new-dark-arrow.svg"
                               padding="pt-0"
                             />

                             <div className=" py-5 text-center position-relative" style={{ overflow: 'hidden', backgroundImage: `url(${OurSuccessBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            <h2 className="FS40FW600 mb-3" style={{ fontFamily: "'Tropiline', sans-serif", fontStyle: 'italic', color: '#94C23C' }}>
              Proven Results <br />
              <span style={{ fontFamily: "'Bricolage Grotesque', serif", fontStyle: 'normal', color: '#141414' }}>That Speak For Themselves</span>
            </h2>
            <p className="plus-sans fw-700 mb-4" style={{ fontSize: '20px', color: '#141414' }}>
              Our Impressive Statistics
            </p>
            <div className="d-flex justify-content-center flex-wrap gap-5">
              {[
                { number: "95", label: "Success Rate" , subLabel : "Target scores within 2 attempts" , symbol: "%" , dir:"right" },
                { number: "94.6", label: '"Stuck" Student Success', subLabel:"Even students' who failed 3+ times" , symbol: "%" , dir:"right"  },
                { number: "79.4", label: "First-Time Success" , subLabel:"Required score on first try" , symbol: "%" , dir:"right"},
                { number: "50k", label: "Successful Students'" , subLabel:"Across all programs, 8+ years" , symbol: "+" , dir:"right" },
                { number: "17", label: "Avg Improvement" ,subLabel:"Significant gains in 21 days" , symbol: "+" , dir:"left" },
              ].map((stat, idx) => (
                <div key={idx} className="d-flex flex-column align-items-center">
                  <h3 style={{ fontFamily: "'Bricolage Grotesque', serif", fontWeight: 800, fontSize: '48px', lineHeight: '120%', color: '#141414', margin: 0 }}>{stat.dir === "left" && <span style={{ color: '#94C23C' }}>{stat.symbol}</span>}
      {stat.number}
      {stat.dir === "right" && <span style={{ color: '#94C23C' }}>{stat.symbol}</span>}</h3>
                  <p className="plus-sans fw-700" style={{ fontSize: '20px', lineHeight: '24px', margin: '12px 0 0', textAlign: 'center' }}>{stat.label}</p>
                  <p style={{ fontSize: '14px', lineHeight: '24px', color: '#686868', margin: '12px 0 0', textAlign: 'center' }}>{stat.subLabel}</p>
                </div>
              ))}
            </div>
            <div className=" d-flex justify-content-center mt-5">
              <ButtonComp link="/auth/register" btnText="Join Our Success Stories" img="/images/web-new-images/new-dark-arrow.svg" />
            </div>
    </div>
      
      {/* Trusted Institutions Section */}
      <div className="custom-container py-5 mb-5 position-relative">
        <div className="text-center mb-5">
          <h2 className="FS40FW600 mb-0">
            <span className="text-dark" style={{ fontFamily: "'Bricolage Grotesque', serif" }}>Trusted by Leading</span><br />
            <span className="green-text">Institutions</span>
          </h2>
        </div>

        <div className="row g-4">
          {institutionCardData.map((card, index) => (
            <div key={index} className="col-lg-4">
              <div className="bg-white p-4 rounded-4 border shadow-sm h-100" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
                <p className="plus-sans fw-600 mb-2 FS16FW500" style={{  color: '#94C23C', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{card.smallHeading}</p>
                <h4 className="plus-sans FS24FW500 fw-600 mb-4" style={{  color: '#141414' }}>{card.title}</h4>
                <div className="d-flex flex-column gap-3">
                  {card.list.map((item, idx) => (
                    <div key={idx} className="d-flex align-items-center gap-2 plus-sans FS16FW500" style={{ color: '#525252' }}>
                      <img src={Smalltick} alt="tick" style={{ width: '22px' }} />
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div style={{ padding: "40px 0 30px 0" }}>
                <CtaBanner
                  title="Ready to Achieve Your "
                  highlight="Target Score?"
                  buttonText="Book Free Consultation"
                  onClick={() => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); }}
                  rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
                  btnText="See Our Programs"
                  subTitle={"Join the thousands of students' who've transformed their futures with Language Academy. Don't let another failed attempt delay your dreams."}
                />
              </div>

      </div> 
      <Footer />
    </React.Fragment>
  );
};

export default About;